export default class ObjectParser {
  static hasEmptyFields = (obj: Object) => {
    const emptyFields = Object.entries(obj).filter((item: any) => {
      const val = item[1];
      return val === null || val === '';
    });

    return emptyFields.length > 0;
  }
}
